import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  currency,
  financialyearstart,
  thousandsdisplay,
} from "../../../Common/Credentials";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { Skeleton } from "@mui/material";

const LineChartComp = ({ order, invoice, type, loader }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (type === "YEAR") {
      let chartdata = [];
      order?.map((e, i) =>
        chartdata.push({
          month: moment(financialyearstart)
            .add(i, "month")
            .startOf("month")
            .format("MMM"),
          order: e,
          grn:
            invoice === undefined ||
              (invoice === null && invoice.length === 0)
              ? 0
              : invoice[i],
        })
      );
      setData(chartdata);
    }

    if (type === "MONTH") {
      let chartdata = [];
      order?.map((e, i) =>
        chartdata.push({
          month: i + 1,
          order: e,
          grn:
            invoice === undefined ||
              (invoice === null && invoice.length === 0)
              ? 0
              : invoice[i],
        })
      );
      setData(chartdata);
    }
    if (type === "WEEK") {
      let chartdata = [];
      order?.map((e, i) =>
        chartdata.push({
          month: i + 1,
          order: e,
          grn:
            invoice === undefined ||
              (invoice === null && invoice.length === 0)
              ? 0
              : invoice[i],
        })
      );
      setData(chartdata);
    }
  }, [order]);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: "#fff",
            borderRadius: 10,
            padding: "10px 14px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: 12, fontWeight: 600, color: "#334155", marginBottom: 6 }}>
            {label}
          </div>
          {payload.map((row, index) => (
            <div key={index} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 3,
                  background: row.color,
                }}
              />
              <span style={{ fontSize: 11, color: "#64748b" }}>{row.name}:</span>
              <span style={{ fontSize: 12, fontWeight: 600, color: "#1e293b" }}>
                {currency}{" "}
                <NumericFormat
                  displayType={"text"}
                  value={row.value}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  disabled={true}
                  thousandSeparator={true}
                  thousandsGroupStyle={thousandsdisplay}
                />
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return loader ? (
    <Skeleton variant="rectangular" width="100%" height={220} sx={{ borderRadius: 2 }} />
  ) : (
    <ResponsiveContainer height={220}>
      <BarChart
        data={data === undefined || data === null ? [] : data}
        margin={{ top: 5, right: 10, left: -10, bottom: 0 }}
        barCategoryGap="25%"
        barGap={3}
      >
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          strokeOpacity={0.3}
          stroke="#cbd5e1"
        />
        <XAxis
          dataKey="month"
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 11, fill: "#94a3b8" }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 11, fill: "#94a3b8" }}
        />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(99,102,241,0.04)" }} />
        <Legend
          iconType="square"
          iconSize={10}
          wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
        />
        <Bar
          dataKey="grn"
          name="GRN Amount"
          fill="#6366f1"
          radius={[4, 4, 0, 0]}
          maxBarSize={20}
        />
        <Bar
          dataKey="order"
          name="Orders"
          fill="#06b6d4"
          radius={[4, 4, 0, 0]}
          maxBarSize={20}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default LineChartComp;
